import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4c1c4e6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a4c1c4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c1c4e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4c1c4e6')) {
      api.createRecord('a4c1c4e6', component.options)
    } else {
      api.reload('a4c1c4e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a4c1c4e6&scoped=true&", function () {
      api.rerender('a4c1c4e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/settlement/index.vue"
export default component.exports